import React,{ Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import FakeProgress from '../../components/FakeProgress';

class Loading extends Component {
  render(){
    return (
      <div className='Loading'>
        <Container>
          <Row>
            <Col xs='12'>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <div className="text-xs-center">
                Partners are more valuable than targets
              </div>
              <FakeProgress />
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/shared/components/Loading/Loading.js